import { DeviceType } from 'app.config';
import { CmsConfiguration, AppIdEnum } from 'cms/cms.config';
import { EcommerceBrandSettingsOysho } from 'idt-ecommerce-api/config/brandSettings.oy';
import { RenderConfiguration } from 'render/render.config';


const CMSCTAPI_BASE_URL = 'http://localhost:4000';
const CMSMGAPI_BASE_URL = 'http://localhost:3000';
const STATIC_SERVER_BASE_URL = 'http://localhost:9000';
const NOTIFIER_BASE_URL = 'http://localhost:4500';
const ECOMMERCE_API_BASE_URL = 'https://preint-oyshocom.inditex.com/itxrest';
const INTERNAL_API_BASE_URL = 'http://localhost:3500';

export const environment: CmsConfiguration = {
  apiEcommerceBaseUrl: ECOMMERCE_API_BASE_URL,
  isProduction: false,
  amandaImageVideoManagerEnabled: true,
  apiBaseUrl: CMSMGAPI_BASE_URL,
  apiProtectedBaseUrl: CMSMGAPI_BASE_URL,
  apiMaterializedUrl: `${CMSMGAPI_BASE_URL}/api/materialized`,
  jsonDraftUrl: CMSMGAPI_BASE_URL,
  jsonPublishedUrl: 'http://localhost:4000',
  assetsUrl: `${STATIC_SERVER_BASE_URL}/`,
  romanUrl: null,
  notifierUrl: `${NOTIFIER_BASE_URL}/sse`,
  disableGuard: false,
  disallowInsecure: false,
  appPreviewBaseUrl: 'oyshodbg:///1/catalog?cmsPath=',
  textStyles: [
    {
      name: 'Cabecera',
      class: 'header',
      styles: {
        color: 'red',
        'font-size': '24pt',
        'line-height': '26pt',
        'text-transform': 'uppercase',
        'font-family': 'serif'
      }
    }, {
      name: 'Text link',
      class: 'text-link',
      styles: {
        color: 'rgb(51,51,51)',
        'font-size': '12px'
      }
    },
    {
      name: 'Roboto Medium',
      class: 'roboto-medium',
      styles: {
        'font-family': 'Roboto-Medium'
      }
    },
    {
      name: 'Roboto Medium Italic',
      class: 'roboto-medium-italic',
      styles: {
        'font-family': 'Roboto-MediumItalic'
      }
    },
    {
      name: 'RobotoCondensed Regular',
      class: 'roboto-condensed-regular',
      styles: {
        'font-family': 'RobotoCondensed-Regular'
      }
    },
    {
      name: 'RobotoCondensed Bold',
      class: 'roboto-condensed-bold',
      styles: {
        'font-family': 'RobotoCondensed-Bold'
      }
    },
    {
      name: 'RobotoCondensed Bold Italic',
      class: 'roboto-condensed-bold-italic',
      styles: {
        'font-family': 'RobotoCondensed-BoldItalic'
      }
    },
    {
      name: 'RobotoCondensed Italic',
      class: 'roboto-condensed-italic',
      styles: {
        'font-family': 'RobotoCondensed-Italic'
      }
    },
    {
      name: 'RobotoCondensed Light',
      class: 'roboto-condensed-light',
      styles: {
        'font-family': 'RobotoCondensed-Light'
      }
    },
    {
      name: 'RobotoCondensed LightItalic',
      class: 'roboto-condensed-light-italic',
      styles: {
        'font-family': 'RobotoCondensed-LightItalic'
      }
    }
  ],
  // The list of color inline styles
  colorStyles: [
    'rgb(97,189,109)', // green300
    'rgb(26,188,156)', // green500
    'rgb(84,172,210)', // blue300
    'rgb(44,130,201)', // green600
    'rgb(147,101,184)', // purple400
    'rgb(71,85,119)', // blue800
    'rgb(209,213,216)', // gray300 --
    'rgb(65,168,95)', // green400
    'rgb(0,168,133)', // green600
    'rgb(61,142,185)', // blue600
    'rgb(41,105,176)', // green800
    'rgb(85,57,130)', // purple600
    'rgb(40,50,78)', // blue900
    'rgb(204,204,204)', // gray400 ---
    'rgb(247,218,100)', // yellow100
    'rgb(251,160,38)', // orange300
    'rgb(235,107,86)', // orange700
    'rgb(226,80,65)', // orange900
    'rgb(163,143,132)', // brown400
    'rgb(0,0,0)', // black
    'rgb(239,239,239)', // gray100 ---
    'rgb(250,197,28)', // orange100
    'rgb(243,121,52)', // orange500
    'rgb(209,72,65)', // red400
    'rgb(184,49,47)', // red800
    'rgb(124,112,107)', // brown800
    'rgb(51,51,51)', // gray900
    'rgb(255,255,255)' // white
  ],
  ecommerce: {
    apiBaseUrl: `${CMSMGAPI_BASE_URL}/proxy/itxrest/2`,
    brandSettings: EcommerceBrandSettingsOysho,
    brandCode: 'oy',
    appId: AppIdEnum.web,
    catalogType: '1',
    instanceType: 'cms',
    providers: {
      cmsConfigurationsBaseUrl: `${INTERNAL_API_BASE_URL}/api/v1/configurations`,
      cmsTranslationsBaseUrl: `${INTERNAL_API_BASE_URL}/api/v1/translations`,
      cmsCollectionsBaseUrl: `${CMSMGAPI_BASE_URL}/api/collections`,
      colbensonSearchUrl: 'https://api-staging.empathybroker.com/search/v1/query/oysho/searchv3'
    }
  },
  breakpoints: [
    {
      bp: '(min-width: 1280px)',
      name: 'Desktop Wide (>= 1280px)',
      device: [DeviceType.DESKTOP_WIDE],
      previewDimensions: {
        width: 1920,
        height: 1200
      }
    },
    {
      bp: '(min-width: 990px) and (max-width: 1279px)',
      name: 'Desktop (990px - 1279px)',
      device: [DeviceType.DESKTOP],
      previewDimensions: {
        width: 1200,
        height: 1024
      }
    },
    {
      bp: '(min-width: 768px) and (max-width: 989px)',
      name: 'Tablet (768px - 989px)',
      device: [DeviceType.TABLET],
      previewDimensions: {
        width: 820,
        height: 1180
      }
    },
    {
      bp: '(max-width: 767px)',
      name: 'Mobile (< 768px)',
      device: [DeviceType.MOBILE],
      previewDimensions: {
        width: 414,
        height: 896
      }
    }
  ],
  storesGroup: [
    {
      id: '1',
      name: 'Africa',
      nameES: 'África',
      stores: [65009636, 65009689, 65009687]
    },
    {
      id: '2',
      name: 'America',
      nameES: 'América',
      stores: [65009665, 65009672, 65009674, 65009648, 65009684, 65009620, 65009683, 65009667, 65009644]
    },
    {
      id: '3',
      name: 'Asia',
      nameES: 'Asia',
      stores: [65009628, 65009649, 65009656, 65009651, 65009653, 65009668]
    },
    {
      id: '4',
      name: 'Europe',
      nameES: 'Europa',
      stores: [65009635, 65009680, 65009676, 65009691, 64009602, 65009643, 65009625, 65009659, 65009634,
        64009608, 64009604, 64009600, 64009613, 64009655, 64009686, 64009601, 65009673, 65009609, 65009650,
        66009607, 64009605, 64009654, 64009647, 64009611, 65009639, 65009658, 65009603, 64009619, 65009624,
        64009610, 65009623, 65009622, 65009660, 65009695, 65009645, 64009648, 64009612, 64009626, 64009621,
        65009663, 64009606]
    },
    {
      id: '5',
      name: 'Middle East',
      nameES: 'Oriente medio',
      stores: [65009637, 65009642, 65009638, 65009632, 65009633, 65009641, 65009640, 65009630, 65009631]
    }
  ],
  fonts: {
    sources: [
      {
        name: 'RobotoCondensed-Regular',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Bold',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-BoldItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Italic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Light',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-LightItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoBold',
        path: '/font/Roboto/RobotoBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoBoldItalic',
        path: '/font/Roboto/RobotoBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoMedium',
        path: '/font/Roboto/RobotoMedium/',
        fontStyle: 'normal',
        fontWeight: '500'
      },
      {
        name: 'RobotoMediumItalic',
        path: '/font/Roboto/RobotoMediumItalic/',
        fontStyle: 'italic',
        fontWeight: '500'
      },
      {
        name: 'RobotoRegular',
        path: '/font/Roboto/RobotoRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoItalic',
        path: '/font/Roboto/RobotoItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoLight',
        path: '/font/Roboto/RobotoLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoLightItalic',
        path: '/font/Roboto/RobotoLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedBold',
        path: '/font/RobotoCondensed/RobotoCondensedBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedBoldItalic',
        path: '/font/RobotoCondensed/RobotoCondensedBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedRegular',
        path: '/font/RobotoCondensed/RobotoCondensedRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedItalic',
        path: '/font/RobotoCondensed/RobotoCondensedItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedLight',
        path: '/font/RobotoCondensed/RobotoCondensedLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedLightItalic',
        path: '/font/RobotoCondensed/RobotoCondensedLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'oysho-icon-font',
        path: '/font/oysho-icon-font/oysho-icon-font/',
        fontStyle: 'normal',
        fontWeight: '400'
      }
    ],
    domains: {
      default: STATIC_SERVER_BASE_URL
    }
  },
  pageTypes: [
    {
      name: 'home',
      label: 'Home'
    },
    {
      name: 'grid',
      label: 'Parrilla'
    },
    {
      name: 'product',
      label: 'Producto'
    }
  ],
  experimentalFeatures: {
    enableAnalyticsCMS: true,
    stylesModule: true,
    timeline: true
  },
  imPolicyList: [
    'oysho-itxhigh',
    'oysho-itxmediumhigh',
    'oysho-itxmedium',
    'oysho-itxmediumlow',
    'oysho-itxlow'
  ],
  analyticsActionsTypes: [
    {
      name: 'image',
      label: 'Imagen'
    },
    {
      name: 'video',
      label: 'Vídeo'
    },
    {
      name: 'text',
      label: 'Texto'
    },
    {
      name: 'product-carousel',
      label: 'Carrusel de productos'
    },
    {
      name: 'carousel',
      label: 'Carrusel de categorías'
    },
    {
      name: 'button',
      label: 'Botón'
    },
    {
      name: 'custom',
      label: 'Personalizado'
    }
  ],
  oauthConfig: {
    endpoint: '',
    appContext: '',
    enableAuth: false
  }
};

export const renderEnvironment: RenderConfiguration = {
  apiEcommerceBaseUrl: ECOMMERCE_API_BASE_URL,
  isProduction: false,
  amandaImageVideoManagerEnabled: true,
  experimentalFeatures: {
    enableAnalyticsCMS: true
  },
  apiMaterializedUrl: `${CMSCTAPI_BASE_URL}/api/materialized`,
  assetsUrl: `${STATIC_SERVER_BASE_URL}/`,
  ecommerce: {
    apiBaseUrl: 'http://localhost:4000/proxy/itxrest/2',
    brandSettings: EcommerceBrandSettingsOysho,
    appId: AppIdEnum.web,
    catalogType: '1',
    instanceType: 'render',
    providers: {
      cmsConfigurationsBaseUrl: `${CMSCTAPI_BASE_URL}/api/config`,
      cmsTranslationsBaseUrl: `${CMSCTAPI_BASE_URL}/api/translations`,
      cmsCollectionsBaseUrl: `${CMSCTAPI_BASE_URL}/api/collections`,
      colbensonSearchUrl: 'https://api.empathybroker.com/search/v1/query/oysho/searchv3'
    }
  },
  breakpoints: [
    {
      bp: '(min-width: 1280px)',
      name: 'Desktop Wide (>= 1280px)',
      device: [DeviceType.DESKTOP_WIDE]
    },
    {
      bp: '(min-width: 990px) and (max-width: 1279px)',
      name: 'Desktop (990px - 1279px)',
      device: [DeviceType.DESKTOP]
    },
    {
      bp: '(min-width: 768px) and (max-width: 989px)',
      name: 'Tablet (768px - 989px)',
      device: [DeviceType.TABLET]
    },
    {
      bp: '(max-width: 767px)',
      name: 'Mobile (< 768px)',
      device: [DeviceType.MOBILE]
    }
  ],
  fonts: {
    sources: [
      {
        name: 'RobotoCondensed-Regular',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Bold',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-BoldItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Italic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-Light',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoCondensed-LightItalic',
        path: '/fonts/RobotoCondensed/'
      },
      {
        name: 'RobotoBold',
        path: '/font/Roboto/RobotoBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoBoldItalic',
        path: '/font/Roboto/RobotoBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoMedium',
        path: '/font/Roboto/RobotoMedium/',
        fontStyle: 'normal',
        fontWeight: '500'
      },
      {
        name: 'RobotoMediumItalic',
        path: '/font/Roboto/RobotoMediumItalic/',
        fontStyle: 'italic',
        fontWeight: '500'
      },
      {
        name: 'RobotoRegular',
        path: '/font/Roboto/RobotoRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoItalic',
        path: '/font/Roboto/RobotoItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoLight',
        path: '/font/Roboto/RobotoLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoLightItalic',
        path: '/font/Roboto/RobotoLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedBold',
        path: '/font/RobotoCondensed/RobotoCondensedBold/',
        fontStyle: 'normal',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedBoldItalic',
        path: '/font/RobotoCondensed/RobotoCondensedBoldItalic/',
        fontStyle: 'italic',
        fontWeight: '700'
      },
      {
        name: 'RobotoCondensedRegular',
        path: '/font/RobotoCondensed/RobotoCondensedRegular/',
        fontStyle: 'normal',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedItalic',
        path: '/font/RobotoCondensed/RobotoCondensedItalic/',
        fontStyle: 'italic',
        fontWeight: '400'
      },
      {
        name: 'RobotoCondensedLight',
        path: '/font/RobotoCondensed/RobotoCondensedLight/',
        fontStyle: 'normal',
        fontWeight: '300'
      },
      {
        name: 'RobotoCondensedLightItalic',
        path: '/font/RobotoCondensed/RobotoCondensedLightItalic/',
        fontStyle: 'italic',
        fontWeight: '300'
      },
      {
        name: 'oysho-icon-font',
        path: '/font/oysho-icon-font/oysho-icon-font/',
        fontStyle: 'normal',
        fontWeight: '400'
      }
    ],
    domains: {
      default: STATIC_SERVER_BASE_URL
    }
  },
  pageTypes: [
    {
      name: 'home',
      label: 'Home'
    },
    {
      name: 'grid',
      label: 'Parrilla'
    },
    {
      name: 'product',
      label: 'Producto'
    }
  ]
};
